import 'babel-polyfill';
import Selectbox from "./util/selectbox";

const selectServer = new Selectbox({
    el:"#select-server",
    scHeight:148
});

const selectMyServer = new Selectbox({
    el:"#select-my-server",
    scHeight:148
});

const selectCht = new Selectbox({
    el:"#select-cht",
    scHeight:148
});

$(document).ready(function () {
    $('body').TopBtn();
    $('.toggle-caution').Folding({open: true});
});


// WEBPACK FOOTER //
// ./src/js/rank.js